import { clsx } from "@/utils";
import { Typography } from "../Typography/Typography";

export interface BlockquoteProps extends React.ComponentProps<"blockquote"> {
  heading: string;
  avatarURL: string;
  alt?: string;
}

export const Blockquote = ({ className, avatarURL, alt = "author", children, heading, ...props }: BlockquoteProps) => {
  const baseClass = "rounded-lg bg-neutral-surface-gray p-5 relative";

  return (
    <blockquote className={clsx(baseClass, className)} {...props}>
      <figure className="flex items-center gap-3">
        <img src={avatarURL} alt={alt} className="h-8 w-8 rounded-full" />
        <figcaption className="flex-1">
          <Typography variant="action" className="lg:leading-tight">
            {heading}
          </Typography>
        </figcaption>
      </figure>
      <Typography className="mt-3">{children}</Typography>
    </blockquote>
  );
};
